import { __assign, __rest } from "tslib";
import React from 'react';
import { max, min } from 'd3-array';
import { BubbleChart, ResponsiveWrapper, BubbleLegend, SeriesLegend, theme as defaultTheme, bubbleColorScale, } from '@keen.io/charts';
import { getValues } from '@keen.io/charts-utils';
import { useLegend } from '@keen.io/react-hooks';
import { LegendContainer } from './bubble-chart.styles';
import ChartWidget from '../chart-widget';
import WidgetHeading from '../widget-heading.component';
import { createLegendLabels } from './bubble-chart.widget.utils';
import { bubbleLegendSettings } from './widget-settings';
export var BubbleChartWidget = function (_a) {
    var _b = _a.legend, legend = _b === void 0 ? bubbleLegendSettings : _b, _c = _a.theme, theme = _c === void 0 ? defaultTheme : _c, title = _a.title, subtitle = _a.subtitle, card = _a.card, tags = _a.tags, props = __rest(_a, ["legend", "theme", "title", "subtitle", "card", "tags"]);
    var data = props.data, valueKey = props.valueKey;
    var values = getValues(data, [valueKey]);
    var minimumVal = min(values);
    var maximumVal = max(values);
    var position = legend.position, series = legend.series, bubble = legend.bubble;
    var scaleColor = bubbleColorScale(theme.colors);
    var _d = useLegend(), disabledKeys = _d.disabledKeys, updateKeys = _d.updateKeys;
    var labels = createLegendLabels(data, props.labelSelector);
    var alignment = series.enabled ? series.alignment : bubble.alignment;
    var layout = series.enabled ? series.layout : bubble.layout;
    var minAreaRadius = props.minAreaRadius, maxAreaRadius = props.maxAreaRadius;
    var maxHeight = bubble.enabled ? 50 : 100;
    return (React.createElement(ChartWidget, { cardSettings: card, legendSettings: {
            position: position,
            alignment: alignment,
            layout: layout,
        }, title: function () { return (React.createElement(WidgetHeading, { title: title, subtitle: subtitle, tags: tags })); }, legend: function () { return (React.createElement(LegendContainer, { position: position, maxHeight: maxHeight },
            series.enabled && (React.createElement(SeriesLegend, __assign({}, series, { disabledKeys: disabledKeys, position: position, onClick: updateKeys, colorPalette: theme.colors, dataSeries: labels.map(function (el) { return ({
                    name: el,
                    color: scaleColor(el),
                }); }) }))),
            bubble.enabled && (React.createElement(BubbleLegend, __assign({ domain: [minimumVal, maximumVal], minRadius: minAreaRadius, maxRadius: maxAreaRadius }, bubble))))); }, content: function () { return (React.createElement(ResponsiveWrapper, null, function (width, height) { return (React.createElement(BubbleChart, __assign({ disabledKeys: disabledKeys, theme: theme, svgDimensions: { width: width, height: height } }, props))); })); } }));
};
export default BubbleChartWidget;
